import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartIcon = () => {
  const { getCartCount, toggleCart } = useCart();
  const count = getCartCount();

  return (
    <button className="cart-icon-btn" onClick={toggleCart} aria-label="Shopping cart">
      <ShoppingCart size={22} />
      {count > 0 && (
        <span className="cart-count">{count > 99 ? '99+' : count}</span>
      )}
    </button>
  );
};

export default CartIcon;
